import init from '../helpers/init';
import 'owl.carousel';
import 'select2';
import 'air-datepicker';
import 'bootstrap';
import '@fancyapps/fancybox';

const {$} = init;
const BX = (<any>window).BX;

export function showAlert(text: any){
  if($('#modalAlert').length){
    $('.js-modal-alert-body').html(text.toString());
    $('#modalAlert').modal('show');
  }
}

$(() => {
  const arrowsNav = [
    '<svg width="8" height="13" viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"><path d="M7 12L1 7L7 1"/></svg>',
    '<svg width="8" height="13" viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"><path d="M1 12L7 7L1 1"/></svg>'
  ];
  $('.brands-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoWidth: true,
    autoplay: true,
    autoplayHoverPause: false,
    autoplaySpeed: 2000,
    autoplayTimeout: 2000,
  });

  $('.page-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: arrowsNav,
    autoplay: true
  });

  $('.contest-carousel').owlCarousel({
    items: 1,
    loop: true,
    nav: true,
    navText: arrowsNav,
    dots: false
  });

  $('.js-contest-slider').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    navText: arrowsNav,
    dots: false,
    margin: 28,
    responsive: {
      500: {
        items: 2
      },
      800: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  });

  $('.photo-slider').owlCarousel({
    items: 2,
    loop: false,
    nav: true,
    dots: false,
    margin: 28,
    navText: arrowsNav,
    responsive: {
      600: {
        items: 3
      },
      800: {
        items: 5
      }
    }
  });

  $('.slider-brands .slider').owlCarousel({
    items: 3,
    loop: false,
    nav: true,
    dots: false,
    margin: 28,
    navText: arrowsNav,
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      800: {
        items: 3
      }
    }
  });
  $('.slider-calendar .slider').owlCarousel({
    items: 3,
    loop: true,
    nav: true,
    margin: 28,
    navText: arrowsNav,
    autoplay: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      800: {
        items: 3
      }
    }
  });

  $('.js-select').select2({
    theme: 'classic',
    minimumResultsForSearch: 0,
    allowClear: true,
    language: {
      noResults() {
        return BX.message('LANGUAGE_ID') === 'en' ? 'No results' : 'Ничего не найдено'
      }
    }
  });

  $('.js-select-header-project').select2({
    theme: 'classic',
    allowClear: true,
    dropdownCssClass: 'select-header-dropdown'
  });
  $('.js-simple-select').select2({
    theme: 'classic',
    minimumResultsForSearch: -1, // Отключение строки поиска
    allowClear: false
  });
  $('.js-select-modal').select2({
    theme: 'classic',
    minimumResultsForSearch: 1,
    dropdownCssClass: "modalsel",
    allowClear: false,
    language: BX.message('LANGUAGE_ID') === 'en' ? 'en' : 'ru'
  });
  $('.js-select-list').select2({
    theme: 'classic',
    maximumSelectionLength: 10,
    minimumResultsForSearch: -1,
    multiple: true,
    allowClear: true
  });

  $('.js-select-multiple').select2({
    theme: 'classic',
    closeOnSelect: false,
    dropdownCssClass: 'multiple-dropdown',
    language: {
      noResults() {
        return BX.message('LANGUAGE_ID') === 'en' ? 'No results' : 'Ничего не найдено'
      }
    }
  });

  $('.js-form-tooltip').tooltip({
    placement: 'right'
  });

  $('[data-bs-toggle="tooltip"]').tooltip();

  $('.js-datepicker').datepicker({
    autoClose: true,
    onSelect(dateText) {
      const url = new URL(<any>window.location);
      url.searchParams.set('d', dateText);
      // @ts-ignore
      history.pushState(null, null, url);
      window.location.reload();
    }
  });

  $(document).on('pjax:complete', function() {
    $('.js-datepicker').datepicker({
      autoClose: true,
      onSelect(dateText) {
        const url = new URL(<any>window.location);
        url.searchParams.set('d', dateText);
        // @ts-ignore
        history.pushState(null, null, url);
        window.location.reload();
      }
    });
  });

  const mainMenu = $('#mainMenu');
  mainMenu.on('show.bs.collapse', () => {
    const header = $('header');
    const height = header.outerHeight();
    header.css('position', 'absolute');
    $('main').css('marginTop', height);
    $('header>.header-horizontal-menu').slideUp();
  });

  mainMenu.on('hide.bs.collapse', () => {
    if ($(window).outerWidth() >= 1400) {
      $('header>.header-horizontal-menu').slideDown();
    }
  });

  mainMenu.on('hidden.bs.collapse', () => {
    $('header').css('position', '');
    $('main').css('marginTop', '');
  });

  $(".header-profile-mobile .user-menu__list .arr").on('click', function () {
    $(this).parent().toggleClass('active');
  });

  $('header .user-menu').on('click', () => {
    if ($(window).outerWidth() <= 992) {
      $("body").toggleClass('profile-open');
      return false;
    }
  });
  $('.close-profile-menu').on('click', () => {
    if ($(window).outerWidth() <= 992) {
      $("body").toggleClass('profile-open');
      return false;
    }
  });

  function scrollCalendarLeft(calendar: any) {
    const position = calendar.band.position().left;
    const board = calendar.band.width() - calendar.wrap.width() + position;
    if (board > 0) {
      calendar.btn.addClass('disabled');
      calendar.band.animate({
        left: position - 160
      }, 600, function () {
        calendar.btn.removeClass('disabled');
      });
    }

  }

  function scrollCalendarRight(calendar: any) {
    const position = calendar.band.position().left;
    if (position + 170 <= 0) {
      calendar.btn.addClass('disabled');
      calendar.band.animate({
        left: position + 170
      }, 600, function () {
        calendar.btn.removeClass('disabled');
      });
    }
  }

  function liveCalendar() {
    $('.live-calendar .calendar-nav').on('click', function () {
      const calendar: any = {};
      calendar['wrap'] = $(this).closest('.live-calendar');
      calendar['btn'] = $(this);
      calendar['band'] = calendar['wrap'].find('.js-calendar-scroll');
      if ($(this).hasClass('day-prev')) {
        scrollCalendarRight(calendar);
      } else {
        scrollCalendarLeft(calendar);
      }
      return false;
    });

    const calendarScroll = document.querySelector('.js-calendar-scroll');
    if(calendarScroll) {
      const navArrows = $('.calendar-nav-arrows');
      // @ts-ignore
      if (calendarScroll.offsetWidth <= calendarScroll.parentNode.offsetWidth) {
        navArrows.remove();
      }
    }
  }

  liveCalendar();

  $(document).on('pjax:complete', function () {
    liveCalendar();
    $('.js-select-multiple').select2({
      theme: 'classic',
      closeOnSelect: false,
      dropdownCssClass: 'multiple-dropdown',
      language: {
        noResults() {
          return BX.message('LANGUAGE_ID') === 'en' ? 'No results' : 'Ничего не найдено'
        }
      }
    });
  });

  $('.js-filter-toggle').on('click', function () {
    $("#catalogFilter .b-filter-toggle").slideToggle();
    const textFilter = $(this).text();
    $(this).text(textFilter === "Скрыть фильтры" ? "Показать фильтры" : "Скрыть фильтры");
    return false;
  });
  $('.js-toggle-text').on('click', function () {
    $(this).parent().toggleClass('show');
    return false;
  });

  function floatLabel(input: HTMLInputElement) {
    if (input.value.trim().length > 0) {
      $(input).next('label').addClass('init-label');
    } else {
      $(input).next('label').removeClass('init-label');
    }
  }

  const floatLabelEl = $('.js-float-label');
  floatLabelEl.each((index, element: HTMLInputElement) => {
    floatLabel(element);
  });
  floatLabelEl.on('change', () => {
    // floatLabel(this);
  });

  initShowMoreTextBlocks();

  $(document).on('click', '.js-show-more-text-block+.js-show-more-text-link, .js-show-more-text-block+.text-end .js-show-more-text-link', function (e) {
    e.preventDefault();
    let link = $(this);
    if (link.prev('.js-show-more-text-block').length || link.parent().prev('.js-show-more-text-block').length) {
      let block = link.prev('.js-show-more-text-block');
      let blockPart = link.parent().prev('.js-show-more-text-block');
      block.css('height', 'auto');
      blockPart.css('height', 'auto');
      block.addClass('active');
      blockPart.addClass('active');
      link.remove();
    }
  });

  function initShowMoreTextBlocks(){
    $('.js-show-more-text-block').each(function () {
      let textBlockHeight = 200;
      let block = $(this);
      const customHeight = block.attr('data-height');
      if(customHeight && customHeight !== undefined){
        textBlockHeight = parseInt(customHeight);
      }
      if(!block.hasClass('js-show-more-init')) {
        if (block.height() <= textBlockHeight) {
          block.addClass('active');
          block.find('+.js-show-more-text-link, +.text-end .js-show-more-text-link').remove();
        } else {
          block.css('height', textBlockHeight + 'px');
          block.addClass('js-show-more-init');
        }
      }
    });
  }

  function scrollChatBand(element: HTMLElement) {
    let wrap = $(element);
    let band = wrap.find('.chat-list');
    let scroll = band.outerHeight() - wrap.outerHeight();
    wrap.animate({
      scrollTop: scroll
    }, 300, function () {
      wrap.find('.chat-preloader').remove();
    });
  }

  $('.js-chat-scroll').each(function () {
    scrollChatBand(this);
  });

  $('a.anchor').on('click', function () {
    let target = $(this).attr('href');
    let top = $(target).offset().top;
    $('body,html').scrollTop(top);
    return false;
  });

  // закрывает модалку
  $(document).on('click', '[data-dismiss="modal"]', function(event){
    event.preventDefault();
    let p = $(this).parents('.modal');
    if(p.length){
      p.modal('hide');
    }
  });

  // youtube ссылка
  $(document).on('submit', 'form.elementEditForm', function(){
    let form = $(this);
    let txtYoutube = '//www.youtube.com';
    let txtVimeo = '//vimeo.com';
    let txtRutube = '//rutube.ru';
    let txtVkvideo = '//vk.com';

    if(form.find('input[name="FP_RU_YOUTUBE_LINK"]').length && form.find('input[name="FP_EN_YOUTUBE_LINK"]').length){
      let ruLink = form.find('input[name="FP_RU_YOUTUBE_LINK"]').val().toString().trim();
      let enLink = form.find('input[name="FP_EN_YOUTUBE_LINK"]').val().toString().trim();

      if(ruLink.length){
        if(ruLink.indexOf(txtYoutube) < 0
          && ruLink.indexOf(txtVimeo) < 0
          && ruLink.indexOf(txtRutube) < 0
          && ruLink.indexOf(txtVkvideo) < 0
        ) {
          form.find('input[name="FP_RU_YOUTUBE_LINK"]').val('');
        }
      }

      if(enLink.length){
        if(enLink.indexOf(txtYoutube) < 0
          && enLink.indexOf(txtVimeo) < 0
          && enLink.indexOf(txtRutube) < 0
          && enLink.indexOf(txtVkvideo) < 0
        ) {
          form.find('input[name="FP_EN_YOUTUBE_LINK"]').val('');
        }
      }

      ruLink = form.find('input[name="FP_RU_YOUTUBE_LINK"]').val().toString();
      enLink = form.find('input[name="FP_EN_YOUTUBE_LINK"]').val().toString();

      if(ruLink.length && !enLink.length){
        form.find('input[name="FP_EN_YOUTUBE_LINK"]').val(ruLink);
      }

      if(!ruLink.length && enLink.length){
        form.find('input[name="FP_RU_YOUTUBE_LINK"]').val(enLink);
      }

    }
  });

  $(document).on('change', 'select.js-profile-country-selector', function(){
    profileCountrySelector();
  });

  profileCountrySelector();

  function profileCountrySelector()
  {
    let countrySelector = '.js-profile-country-selector';
    let regionSelectorBlock = '.js-russian-regions-block';
    if($(countrySelector).length && $(regionSelectorBlock).length){
      let o = $(countrySelector).find('option:selected');

      if(o.attr('data-country-code') && o.attr('data-country-code') !== undefined && o.attr('data-country-code') === 'RUS'){
        // если Россия - показываем регионы
        $(regionSelectorBlock).show();
      }else{
        // если другая страна - регионы не показываем
        $(regionSelectorBlock).hide();
        $(regionSelectorBlock).find('select.js-simple-select').find('option').eq(0).prop('selected', true);
        $(regionSelectorBlock).find('select.js-simple-select').trigger('change');
      }
    }
  }

  $(document).on('click', '.js-create-barcodes-for-badges', function(e){
    e.preventDefault();

    let btn = $(this);
    let xml = btn.attr('data');

    if (xml) {
      btn.prop('disabled', 'disabled');

      $.ajax(
        {
          type: 'POST',
          url: '/local/ajax/office/Exhibitions/generate-badges-barcodes/',
          data: {
            'xml': xml
          },
          dataType: 'html',
          success: function(html){
            alert(BX.message('LANGUAGE_ID') === 'en' ? 'Done. Total: ' + html : 'Готово. Сгенерировано: ' + html);
            btn.removeAttr('disabled');
          },
        }
      )
    }
  });

  $(document).on('click', '.js-ticket-remove-order-payment', function(e){
    e.preventDefault();

    let warning = confirm(BX.message('LANGUAGE_ID') === 'en'
      ? 'Attention! If the payment entity is removed from the order, your company may receive a penalty for an unopened receipt. Are we continuing?'
      : 'Внимание! В случае удаления сущности оплаты у заказа ваша компания может получить штраф за непробитый чек. Продолжаем?');

    let obj = $(this);

    if (!warning) {
      return;
    }

    let orderId = obj.data('id');

    if (!orderId) {
      return;
    }

    $.ajax(
      {
        type: 'POST',
        url: '/local/ajax/office/Tickets/remove-order-payments/',
        data: {
          'id': orderId
        },
        dataType: 'json',
        success: function(data){
          if (data.success) {
            location.reload();
          }
        },
      }
    )
  });
});
